import React, { useEffect, useState } from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import PortfolioSection from '../components/PortfolioSection';
import AboutSection from '../components/AboutSection';
import ContactSection from '../components/ContactSection';
import API from "../config/axios";
import { api_paths } from '../config/api.paths';
import { scrollToSection } from '../utils/utils';

const Home = ({ scrollTo }) => {
    const [heroSectionData, setHeroSectionData] = useState();
    const [aboutUsData, setAboutUsData] = useState();
    const [servicesData, setServicesData] = useState();
    const [portfolioData, setPortfolioData] = useState();
    const [contactData, setContactData] = useState();

    // Auto-scroll when this page is loaded via a deep-link route (e.g. /about_us)
    useEffect(() => {
        if (scrollTo) {
            // Delay so the DOM has time to render all sections
            setTimeout(() => {
                scrollToSection(scrollTo, () => {});
            }, 300);
        }
    }, [scrollTo]);

    useEffect(() => {
        const fetchCMSData = async () => {
            try {
                const response = await API.get(api_paths.CMS.get);
                const cmsData = response?.data?.payload?.data?.cmsPages || [];

                const heroSectionData = cmsData.find(page => page.slug === 'herosection');
                setHeroSectionData(heroSectionData ?? null);
                
                const abooutUs = cmsData.find(page => page.slug === 'about-us');
                setAboutUsData(abooutUs ?? null);
                
                const services = cmsData.find(page => page.slug === 'services');
                setServicesData(services ?? null);

                const portfolio = cmsData.find(page => page.slug === 'portfolio');
                setPortfolioData(portfolio ?? null);

                const contact = cmsData.find(page => page.slug === 'contact-us');
                setContactData(contact ?? null);
                
            }catch (err){
                console.error('Error fetching CMS data: ', err);
            }
        }

        fetchCMSData();
    }, []);

    return (
        <>
            <HeroSection data={heroSectionData} />
            <PortfolioSection data={portfolioData} />
            <ServicesSection data={servicesData} />
            <AboutSection data={aboutUsData} />
            <ContactSection data={contactData} />
        </>
    );
};



export default Home;
